<div class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-12">
        <ol class="breadcrumb float-sm-left">
          <li class="breadcrumb-item">
            <a [routerLink]="['/']">
              <i class="fas fa-home"></i>
              Página Inicial</a>
          </li>
          <li class="breadcrumb-item">
            <a [routerLink]="['/papeis-trabalho']">Papéis de Trabalho</a>
          </li>
          <li class="breadcrumb-item active">{{ titulo }}</li>
        </ol>
      </div> 
    </div>
  </div>
</div>
<div class="content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card card-outline card-lightblue">
          <div class="card-header">
            <h3 class="card-title mb-0">
              <i *ngIf="this.id" class="fas fa-pencil-alt pr-2"></i>
              <i *ngIf="!this.id" class="far fa-file pr-2"></i>
              {{ titulo }}
            </h3>
          </div>
          <div class=" card-body">
            <div class="row">
              <div class="form-group col-md-12">
                <label for="nome" class="mb-1">Nome</label>
                <input [attr.disabled]="visualizar || listPapeis.length > 0 ? true : null" type="text" 
                  id="inputNome" class="form-control form-control-sm" 
                  [(ngModel)]="txtNome"
                  [ngClass]="{ 'is-invalid': validaForm('nome')}"
                  maxlength="200" />                
                <div *ngIf="validaForm('nome')" class="campo-obrigatorio">
                  <div>Campo obrigatório</div>
                </div>
              </div>              
            </div>
            <div class="row">
              <div class="form-group col-md-4">
                <label for="selectTipo" class="mb-1">Tipo de Trabalho</label>
                <select
                  id="selectTipo"
                  class="form-control form-control-sm"
                  [attr.disabled]="visualizar ? true : null"
                  [(ngModel)]="selectedTipo"
                  [ngClass]="{ 'is-invalid': validaForm('tipo')}"
                  (change)="changeTipo($event)">
                  <option
                    *ngFor="let item of listTipoTrabalho"
                    [value]="item.id">
                    {{ item.nome }}
                  </option>
                </select>
                <div *ngIf="validaForm('tipo')" class="campo-obrigatorio">
                  <div>Campo obrigatório</div>
                </div>
              </div>

              <div class="form-group col-md-4">
                <label for="selectTipo" class="mb-1">Fases do Tipo de Trabalho</label>
                <select
                  id="selectTipo"
                  class="form-control form-control-sm"
                  [(ngModel)]="selectedFase"
                  [ngClass]="{ 'is-invalid': validaForm('fase')}"
                  [attr.disabled]="visualizar ? true : null">
                  <option
                    *ngFor="let item of listFases"
                    [value]="item.id">
                    {{ item.nome }}
                  </option>
                </select>
                <div *ngIf="validaForm('fase')" class="campo-obrigatorio">
                  <div>Campo obrigatório</div>
                </div>
              </div>

              <div class="form-group col-md-4">
                <label for="selectSituacao" class="mb-1">Situação do Papel</label>
                <select
                  id="selectSituacao"
                  class="form-control form-control-sm"
                  [(ngModel)]="selectedSituacao"
                  [ngClass]="{ 'is-invalid': validaForm('situacao')}"
                  [attr.disabled]="visualizar ? true : null">
                  <option
                    *ngFor="let item of listSituacao"
                    [value]="item.codigo">
                    {{ item.descricao }}
                  </option>
                </select>
                <div *ngIf="validaForm('situacao')" class="campo-obrigatorio">
                  <div>Campo obrigatório</div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header bg-light">
                    Tipos de Papéis Aceitáveis (Selecione pelo menos um item)
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12">
                        <mat-checkbox
                          [disabled]="visualizar"
                          color="primary"
                          name="switchCheckPapelAceitavel"
                          [(ngModel)]="checkColetado">
                          Coletado
                        </mat-checkbox>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <mat-checkbox
                          [disabled]="visualizar"
                          color="primary"
                          name="switchCheckPapelAceitavel"
                          [(ngModel)]="checkNaoColetado">
                          Não-Coletado
                        </mat-checkbox>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <mat-checkbox
                          [disabled]="visualizar"
                          color="primary"
                          name="switchCheckPapelAceitavel"
                          [(ngModel)]="checkProduzido">
                          Produzido pelo Auditor
                        </mat-checkbox>
                      </div>
                    </div>                      
                  </div>
                </div>
                <div *ngIf="validaForm('checks')" class="campo-obrigatorio">
                  <div>Campo obrigatório</div>
                </div>
              </div>
            </div>
            <div class="row mb-2" *ngIf="this.visualizar == false">
              <div class="col-md-12">
                <button
                  type="button"
                  class="btn btn-success btn-sm mr-1"
                  style="font-size: 14px;"
                  (click)="add()">
                  Adicionar
                </button>
                &nbsp;
                <button
                  type="button"
                  class="btn btn-secondary tn-sm mr-1"
                  style="font-size: 14px;"
                  (click)="limpar()">
                  Limpar
                </button>                                    
              </div>
            </div>            

            <div class="row" *ngIf="listPapeis.length > 0">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header bg-light">
                    <div class="row">
                      <div class="col-md-3">
                        Nome
                      </div>
                      <div class="col-md-3">
                        Tipo de Trabalho
                      </div>
                      <div class="col-md-3">
                        Fase
                      </div>
                      <div class="col-md-2">
                        Situação
                      </div>
                      <div class="col-md-1 text-center">
                        Editar/Remover
                      </div>
                    </div>
                  </div>
                  <div class="card-body">                      
                    <div class="row" *ngFor="let item of listPapeis">
                      <div class="col-md-3">
                        {{ item.nome }}
                      </div>
                      <div class="col-md-3">
                        {{ item.tipoNome }}
                      </div>
                      <div class="col-md-3">
                        {{ item.faseNome }}
                      </div>
                      <div class="col-md-2">
                        {{ item.situacaoNome }}
                      </div>
                      <div class="col-md-1 text-center">
                        <button *ngIf="this.visualizar == false"
                          type="button"
                          class="btn btn-secondary btn-xs text-left"
                          (click)="editar(item)">
                          <i class="fa fa-pen"></i>
                        </button>
                        &nbsp;
                        <button *ngIf="this.visualizar == false"
                          type="button"
                          class="btn btn-danger btn-xs text-left"
                          (click)="remover(item)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    </div>                      
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="card-footer">
            <div class="btn-group" [hidden]="visualizar">
              <button class="btn btn-primary btn-sm mr" (click)="salvarDados(false)">
                  <i class="far fa-save"></i> Salvar
              </button>                
              <button type="button" class="btn btn-primary btn-sm mr dropdown-toggle dropdown-icon" data-toggle="dropdown" aria-expanded="false"></button>
              <div class="dropdown-menu" role="menu">
              <a class="dropdown-item" (click)="salvarDados(false)">Salvar</a>
              <a class="dropdown-item" (click)="salvarDados(true)">Salvar e fechar</a>
              </div>
            </div>
            &nbsp;
            <button [hidden]="visualizar" type="button" class="btn btn-default btn-sm" (click)="onBack()">
              <i class="fas fa-times"></i> Cancelar
            </button>

            <button [hidden]="!visualizar" type="button" class="btn btn-default btn-sm" (click)="onBack()">
              <i class="fas fa-times"></i> Sair
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
